import { Component, OnInit, ChangeDetectionStrategy, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';
import { environment } from '@env/environment';
import { select, Store } from '@ngrx/store';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as loginSelectors from '../../../../../root-store/login-store/login.selector';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'user-invite-success-screen',
  templateUrl: './user-invite-success-screen.component.html',
  styleUrls: ['./user-invite-success-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInviteSuccessScreenComponent implements OnInit, OnDestroy {
  ShareUrl;
  isProfessional = false;
  subscription = new Subscription();
  user;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private _clipboardService: ClipboardService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<UserInviteSuccessScreenComponent>,
    private _store: Store
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.user = result;
        }
      })
    );

    if (this.data?.isPrefessional) {
      this.isProfessional = true;
    }

    if (this.data != undefined && this.data.email != undefined) {
      if (!!this.data?.isTransferOwnership) {
        this.ShareUrl = this.data?.user?.link;
      } else if (this.data?.user?.user_type == 'Professional') {
        if (this.data.user?.first_name && this.data.user?.last_name) {
          this.ShareUrl = `${environment.baseUrl.toString()}/signup-professional/${this.toHex(this.data.email.toLowerCase())}/${this.toHex(
            this.data.user.first_name
          )}/${this.toHex(this.data.user.last_name)}`;
        } else {
          this.ShareUrl = `${environment.baseUrl.toString()}/signup-professional/${this.toHex(this.data.email.toLowerCase())}`;
        }
      } else {
        if (this.data.user?.first_name && this.data.user?.last_name) {
          this.ShareUrl = `${environment.baseUrl.toString()}/signup-family/${this.toHex(this.data.email.toLowerCase())}/${this.toHex(
            this.data.user.first_name
          )}/${this.toHex(this.data.user.last_name)}`;
        } else {
          this.ShareUrl = `${environment.baseUrl.toString()}/signup-family/${this.toHex(this.data.email.toLowerCase())}`;
        }
      }
    }
  }

  copy() {
    this._clipboardService.copy(this.ShareUrl);
    this.toastr.success('Link copied!');
  }

  toHex(s: any) {
    // utf8 to latin1
    s = unescape(encodeURIComponent(s));
    var h = '';
    for (var i = 0; i < s.length; i++) {
      h += s.charCodeAt(i).toString(16);
    }
    return h;
  }

  closedialog() {
    this.dialogRef.close();
    document.getElementById('mainNavWrapperContainer').click();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
